import { useTranslation } from 'react-i18next'
import { LOCALES } from '~/locales'

export const useHelpCenterUrl = (id: string) => {
  const { i18n } = useTranslation()
  const lang = i18n.resolvedLanguage === LOCALES.ZH ? 'zh-cn' : 'en-us'
  return `https://support.tokenlon.im/hc/${lang}/articles/${id}`
}
